import getMonitoringOnly from './getMonitoringOnly'

export const monitoringSites = {
  getMonitoringOnly,
}
